import httpRequest from '../../common/lib/http-request';

// *******************
// BALLOT SERVICES
// *******************

function getBallotStatus(tokenIdentifier) {
    return httpRequest({
        url: '/Associate/ballot/status/' + tokenIdentifier,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const BallotService = { getBallotStatus }

export default BallotService;